module.exports = {
	RECEIVE_ALL_UNITS: 'RECEIVE_CITIES',
	RECEIVE_ALL_REMARKS: 'RECEIVE_ALL_REMARKS',
	RECEIVE_ALL_SUPPORTS: 'RECEIVE_ALL_SUPPORTS',
	RECEIVE_ALL_STANDARD_CODIFICATION: 'RECEIVE_ALL_STANDARD_CODIFICATION',
	RECEIVE_ALL_PARAMETERS: 'RECEIVE_ALL_PARAMETERS',
	RECEIVE_ALL_CITIES: 'RECEIVE_ALL_CITIES',
	RECEIVE_ALL_DEPARTMENTS: 'RECEIVE_ALL_DEPARTMENTS',
	RECEIVE_ALL_FILTER_TYPES: 'RECEIVE_ALL_FILTER_TYPES',
	RECEIVE_ALL_SITE_TYPES: 'RECEIVE_ALL_SITE_TYPES',
	RECEIVE_ALL_WATERSHED: 'RECEIVE_ALL_WATERSHED',
	RECEIVE_ALL_STATIONS: 'RECEIVE_ALL_STATIONS',
	RECEIVE_ALL_SOURCES: 'RECEIVE_ALL_SOURCES',
	RECEIVE_ALL_INDICATOR_TYPES: 'RECEIVE_ALL_INDICATOR_TYPES',
	RECEIVE_ALL_INDICATORS: 'RECEIVE_ALL_INDICATORS',
	RECEIVE_ALL_MANAGEMENT_WATER: 'RECEIVE_ALL_MANAGEMENT_WATER',
	RESET_REFERENTIAL: 'RESET_REFERENTIAL'
}



// WEBPACK FOOTER //
// ./src/referential/constants/ReferentialConstants.js